<template>
  <div class="layouts-content-view">
    <div
      v-if="isLoading"
      class="layouts-content-view__state"
    >
      <b-spinner />
    </div>

    <div
      v-else-if="items.length === 0"
      class="layouts-content-view__state"
    >
      No layouts found.
    </div>

    <ItemGrid
      v-else
      :items="gridItems"
      :columns="GRID_COLUMNS"
      :columns-md="GRID_COLUMNS_MD"
      @item-click="showLayoutPreviewModal($event.id)"
    />

    <ItemPagination
      v-if="lastPage > 1"
      v-model="currentPage"
      :total-rows="lastPage * pageSize"
      :per-page="pageSize"
      @change="fetchLayouts"
    />

    <LayoutPreviewModal
      ref="layoutPreviewModal"
      @add-layers="onAddLayers"
    />
  </div>
</template>

<script>
import ItemGrid from '@frontend/components/modules/file-browser/browser/ItemGrid.vue';
import ItemPagination from "@frontend/components/modules/file-browser/browser/ItemPagination.vue";
import LayoutAPI from '@frontend/services/api/layout';
import LayoutPreviewModal from '@frontend/components/modules/layouts-page/modals/layout-preview/LayoutPreviewModal.vue';
import { GRID_COLUMNS, GRID_COLUMNS_MD, GRID_PAGE_SIZE } from '@frontend/constants/select-image-grid';
import { FILE_TYPE } from '@frontend/constants/file-image-types';

export default {
  name: 'LayoutsContentView',

  components: {
    ItemGrid,
    ItemPagination,
    LayoutPreviewModal,
  },

  props: {
    pageSize: {
      type: Number,
      default: GRID_PAGE_SIZE,
    },
  },

  data() {
    return {
      items: [],
      currentPage: 1,
      lastPage: 0,
      isLoading: false,
      GRID_COLUMNS,
      GRID_COLUMNS_MD,
    };
  },

  computed: {
    gridItems() {
      return this.items.map((layout) => ({
        id: layout.id,
        name: layout.name,
        type: FILE_TYPE.IMAGE,
        thumbnail_path: `/share?file=${layout.thumbnail}`,
      }));
    },
  },

  created() {
    this.fetchLayouts(1);
  },

  methods: {
    async fetchLayouts(page = 1) {
      this.isLoading = true;

      try {
        const { data } = await LayoutAPI.getLayouts({
          params: {
            page,
            limit: this.pageSize,
          },
        });

        this.items = data.layouts || [];
        this.currentPage = page;
        this.lastPage = Math.ceil((data.totalCount || 0) / this.pageSize);
      } catch (error) {
        console.error('Error fetching layouts:', error);
        toastr.error('Failed to load layouts');
      } finally {
        this.isLoading = false;
      }
    },

    showLayoutPreviewModal(layoutId) {
      this.$refs.layoutPreviewModal.show(layoutId);
    },

    onAddLayers({ images, texts }) {
      this.$refs.layoutPreviewModal.hide();
      this.$emit('onLayoutLayers', { images, texts });
    },
  },
};
</script>

<style scoped>
.layouts-content-view {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.layouts-content-view__state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: #73808c;
}
</style>
